import { render, staticRenderFns } from "./files-imports.vue?vue&type=template&id=139d09ae&"
import script from "./files-imports.vue?vue&type=script&lang=js&"
export * from "./files-imports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports